import React from "react";
import classNames from "classnames";
import { RiLinkedinFill } from "react-icons/ri";
import { BsInstagram } from "react-icons/bs";

// assets
import styles from "@/assets/styles/components/landing-socials.module.scss";

const HEADER_SOCIAL_LINKS = [
  {
    href: "https://www.linkedin.com/company/location-live-limited/?viewAsMember=true",
    label: <RiLinkedinFill className={styles["locl-socials__item-icon"]} />,
    ariaLabel: "linkedin logo"
  },
  {
    href: "https://www.instagram.com/loc_live/?hl=en",
    label: <BsInstagram className={styles["locl-socials__item-icon"]} />,
    ariaLabel: "instagram logo"
  }
];

const LandingSocials = () => {
  return (
    <ul className={classNames(styles["locl-socials"], "locl-header-socials")} data-testid="locl-socials">
      {HEADER_SOCIAL_LINKS.map((item, index) => (
        <li key={`locl-header-social-link-${index}`} className={styles["locl-socials__item"]}>
          <a
            target="_blank"
            href={item.href}
            rel="noreferrer"
            className={classNames(
              styles["locl-socials__item-link"],
              "locl-header-socials__item-link"
            )}
          >
            {item.label}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default LandingSocials;
